import { render, staticRenderFns } from "./CreateTab.vue?vue&type=template&id=d3d8d400&scoped=true"
import script from "./CreateTab.vue?vue&type=script&lang=js"
export * from "./CreateTab.vue?vue&type=script&lang=js"
import style0 from "./CreateTab.vue?vue&type=style&index=0&id=d3d8d400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d8d400",
  null
  
)

export default component.exports